<template>
  <Card padding-less outlined>
    <Row class="align-center pa-6">
      <Col cols="12 col-sm-12 col-md-5">
        <h4
          class="text-h4 text-truncate font-weight-medium mb-2"
          v-text="site.address"
        />
        <PlanInfo :plan="site.plan" :isAdditional="site.isAdditional" />
      </Col>
      <Col cols="12 col-sm-12 col-md-5">
        <MultiLanguage
          v-if="shouldShowMultiLanguage"
          v-bind="site.multiLanguage"
        />
      </Col>
      <Col cols="12 col-sm-12 col-md-2">
        <Button
          color="primary"
          :label="lc.manageButton"
          outlined
          v-bind="siteLink"
        />
      </Col>
    </Row>
  </Card>
</template>
<script>

import { Card, Button, Row, Col } from '@locaweb/design-system-vue'
import MultiLanguage from './SiteCard/MultiLanguage.vue'
import PlanInfo from './SiteCard/PlanInfo.vue'

export const buildOldPanelURL = (siteId) =>
  `${process.env.VUE_APP_LWSITE_PANEL_URL}/panel/sites/${siteId}/select`

export default {
  name: 'SiteCard',
  components: {
    Row,
    Col,
    Card,
    Button,
    PlanInfo,
    MultiLanguage
  },
  props: {
    site: {
      type: Object,
      required: true
    }
  },
  computed: {
    lc () {
      return this.$lc('site.components.siteCard')
    },
    shouldShowMultiLanguage () {
      return 'multiLanguage' in this.site
    },
    siteLink () {
      if (!this.site.isIncluded) {
        return { href: buildOldPanelURL(this.site.id) }
      }

      return { to: { name: 'siteWelcome', params: { siteId: this.site.id } } }
    }
  }
}
</script>
